import { TextLink } from "../../../../components/link/TextLink";
import { linksContainer } from "./styles.css";
import { useLanguage } from "../../../../../providers/language/context";
import { graphql, useStaticQuery } from "gatsby";

export const LinksBlock = () => {
  const { language } = useLanguage();

  const textQuery = useStaticQuery(graphql`
    query {
      allPagesJson {
        nodes {
          title
          language
          fields {
            bodyParsed {
              findUs
              links {
                LINKED_IN
              }
            }
          }
        }
      }
    }
  `);

  const textResource =
    textQuery.allPagesJson.nodes.find(
      (i: Record<string, string | number>) =>
        i?.language === language && i?.title === "Footer",
    ) ??
    textQuery.find(
      (i: Record<string, string | number>) =>
        i?.language === "en" && i?.title === "Footer",
    );
  const findUs = textResource?.fields?.bodyParsed?.findUs ?? "";
  const { LINKED_IN = "" } = textResource?.fields?.bodyParsed?.links ?? {};

  return (
    <div className={linksContainer}>
      <span>{findUs} </span>
      {LINKED_IN && (
        <TextLink isExternal to={LINKED_IN}>
          LinkedIn
        </TextLink>
      )}
      {/* <span>, </span>
      <TextLink isExternal to={YOUTUBE}>
        YouTube
      </TextLink>
      <span>, </span>
      <TextLink isExternal to={TIKTOK}>
        TikTok
      </TextLink>
      <span>, </span>
      <span>and&nbsp;</span>
      <TextLink isExternal to={INSTAGRAM}>
        Instagram
      </TextLink> */}
    </div>
  );
};
